import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const skipped = (ctx: any, value: any) => (ctx.p0.skip || ctx.p1.skip ? value : undefined);

interface ICropPriceGraphProps {
  labels: string[];
  lastYearData: (number | null)[];
  thisYearData: (number | null)[];
}

export const CropPriceGraph = ({ labels, lastYearData, thisYearData }: ICropPriceGraphProps) => {
  const options: ChartOptions<'line'> = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          color: '#ececf3',
        },
      },
      y: {
        grid: {
          color: '#ececf3',
        },
      },
    },
  };

  const thisYearDataForDisplay = thisYearData.map((data) => data ?? NaN);
  const lastYearDataForDisplay = lastYearData.map((data) => data ?? NaN);

  const data = {
    labels,
    datasets: [
      {
        label: '올해',
        data: thisYearDataForDisplay,
        borderColor: 'rgb(82,106,255)',
        backgroundColor: 'rgba(82,106,255,0.5)',
        pointBackgroundColor: 'rgb(82,106,255)',
        segment: {
          borderDash: (ctx: any) => skipped(ctx, [6, 6]),
        },
        spanGaps: true,
      },
      {
        label: '작년',
        data: lastYearDataForDisplay,
        borderColor: 'rgb(199,199,214)',
        backgroundColor: 'rgba(199,199,214,0.5)',
        pointBackgroundColor: 'rgb(199,199,214)',
        segment: {
          borderDash: (ctx: any) => skipped(ctx, [6, 6]),
        },
        spanGaps: true,
      },
    ],
  };

  return (
    <GraphContainer>
      <Line options={options} data={data} />
      <DescriptionContainer>
        <Icon name={'CircleExclamation'} size={'Medium'} fill={'#A7A9B6'} />
        <GraphDescription>{'작년과 올해의 1kg당 평균가를 일별 그래프로 제공해요!'}</GraphDescription>
      </DescriptionContainer>
    </GraphContainer>
  );
};

const GraphContainer = styled.div`
  padding: 8px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  background: var(--Light-Scheme-Monochrome-grey10, #ffffff);
`;

const DescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

const GraphDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-align: center;

  /* Display/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 15.6px */
`;
